'use client';

import { useMemo } from 'react';

import { Flex } from '@chakra-ui/react';

import { listingStateSlice, useAppSelector } from '@app/app-state';
import { ListingActiveFilters } from '@app/components/molecules/listing-active-filters';
import { filterComponents } from '@app/components/organisms/filter-components';
import { ListingFiltersProps } from '@app/components/organisms/listing-filters/listing-filters.props';
import { ListingFiltersDrawer } from '@app/components/organisms/listing-filters/listing-filters-drawer';
import { useIsMobileRes } from '@app/hooks/useIsMobileRes';
import { useSearchFilters } from '@app/hooks/useSearchFilters';

export const ListingFilters = ({ variant, availableOptions }: ListingFiltersProps) => {
    const isMobileRes = useIsMobileRes();
    const realTimeItemCount = useAppSelector(
        listingStateSlice.selectors.selectListingRealTimeItemCount,
    );
    const { filterItems, handleApplyFilters, handleClearFilters, createReservationSwitch } =
        useSearchFilters({ availableOptions, withCounter: true });

    const filtersContent = useMemo(
        () => (
            <Flex direction="column" gap={8}>
                {createReservationSwitch({
                    accommodationCount: realTimeItemCount,
                })}

                {filterItems?.map((item, index) =>
                    filterComponents[item.componentType]?.(item, index),
                )}
            </Flex>
        ),
        [createReservationSwitch, filterItems, realTimeItemCount],
    );

    if (variant === 'mobile' && isMobileRes) {
        return (
            <ListingFiltersDrawer
                onApplyFilters={handleApplyFilters}
                onClearFilters={handleClearFilters}
            >
                <ListingActiveFilters withScrollableWrapper={true} mb={4} />
                {filtersContent}
            </ListingFiltersDrawer>
        );
    }

    if (variant === 'desktop' && !isMobileRes) {
        return (
            <Flex direction="column" gap={5}>
                {filtersContent}
            </Flex>
        );
    }

    return null;
};
